
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import { RunTableProps } from './RunTable.types'
import { ChevronRight, ChevronLeft } from 'react-bootstrap-icons'
import useSWR from 'swr'

import { useRuns } from '../hooks'

import { Logo } from '../atoms'
import RunRow from './RunRow'

import './RunTable.scss'

export const RunTable: React.FC<RunTableProps> = ({ 
  projectOwner,
  projectName,
  study,
  client,
  authUser,
  style,
  getFileCard,
  getFolderCard,
}) => {
  const { listRuns } = useRuns(client)

  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState<number>(20)

  const { data, error } = useSWR(
    authUser && study ? [projectOwner, projectName, study.id, 
      page, perPage]: undefined, 
    listRuns,
    {
      revalidateOnFocus: false,
      refreshInterval: study.status.finished_at ? 5000 : undefined,
      errorRetryCount: 3,
      onSuccess: (run) => {
        if (page > run.page_count) {
          setPage(run.page_count)
        }
      } 
    }
  )

  if (error) return <h1>Error</h1>
  if (!data) return <div>
    <span style={{ float: 'left', margin: '0 5px 0 0' }}>
      <Logo />
    </span> Loading ...
    </div>

  const btnStyle: React.CSSProperties = { 
    all: 'unset',
    cursor: 'pointer',
    border: '1px solid #d9d9d9',
    fontSize: '11px',
    color: '1px solid #d9d9d9',
    textAlign: 'center',
    padding: '8px 8px',
    borderRadius: '2px',
    margin: '10px 0 0 0',
    width: '16px',
    flexShrink: 0,
  }

  const btnPgStyle = (k: number) : React.CSSProperties=> ({
    ...btnStyle,
    border: data.page !== (k + 1) ? '1px solid #d9d9d9' : '1px solid var(--primary)',
    color: data.page !== (k + 1) ? '#000000d9' : 'var(--primary)',
    margin: '0 4px 0 4px',
  })

  return(<>
    <div >
      {data.resources.map((item, index) => ( <RunRow 
        key={`run-${item.id}`}
        projectOwner={projectOwner}
        projectName={projectName}
        run={item}
        index={(index + 1) + (page - 1) * perPage}
        client={client}
        authUser={authUser}
        style={style}
        getFileCard={getFileCard}
        getFolderCard={getFolderCard}
      />
      ))}

      <div className='run-navigator'>
        <div>
          <button
            style={{ ...btnStyle, cursor: `${ page - 1 < 1 ? 'not-allowed': 'pointer' }` } }
            disabled={!data.resources}
            onClick={() => setPage(p => {
              return p - 1 > 1 ? p - 1 : 1
            })}
            >
            <ChevronLeft />
          </button>
        </div>
        
        <div style={{ margin: '10px auto 0 auto' }} className='container-scroll'> 
          {data.resources && Array.from(Array(data.page_count).keys()).map((k) => {
            return (
              <button
                key={`page-${k}`}
                onClick={(e) => {
                  setPage(k + 1)
                }}
                style={btnPgStyle(k)}>
                {k + 1}
              </button>
            )
          })}
        </div>

        <div style={{ margin: '10px auto 0 auto' }} >
          <input 
            title='Number of rows for page' 
            onChange={(e) => {
              let val = parseInt(e.target.value)
              if (val > 100) val = 100 // Max 100
              if (!val) val = 1 // Min 1
              setTimeout(() => {
                setPerPage(val)
              }, 3000) // Refresh after 3s
            }}
            className='run-pg-input'
            type='number' 
            min={1} 
            max={data.total_count} 
            defaultValue={perPage} />
        </div>

        <div>
          <button
            style={{ ...btnStyle, cursor: `${ page >= data.page_count ? 'not-allowed': 'pointer' }` } }
            disabled={!data.next_page}
            onClick={() => setPage(p => p + 1)}
          >
            <ChevronRight />
          </button>
        </div>
      </div>
    </div>
  </>)
}

export default RunTable

